import { validatorRequireNumber } from '@/utils/validators';
import InputNumber from '@/components/DSE/InputNumber';
import MDinput from '@/components/MDinput';

export function getFormDefinition(vue) {
  return {
    positionCode: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'stock.positionCode'
      }
    },
    quantityOrderedInMeters: {
      type: InputNumber,
      props: {
        caption: 'fabricOrder.orderedQuantity',
        step: 0.5,
        precision: 2
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    totalQuantityDeliveredInMeters: {
      type: MDinput,
      props: {
        caption: 'fabricOrder.totalDeliveredQuantity',
        readonly: true
      }
    },
    quantityEnteredInMeters: {
      type: InputNumber,
      props: {
        caption: 'fabricOrder.deliveredQuantity',
        step: 0.5,
        precision: 2
      },
      dynamicProps: form => ({
        min: form.stockedQuantityInMeters
      })
    },
    remarks: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'common.remarks',
        maxlength: 64
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}

export default getFormDefinition;
